const getArray = (size: number) => new Array(size).fill(1);

export default getArray;
